import * as React from "react";

function SvgGrupo2662(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} {...props}>
      <g data-name="Grupo 2662" transform="translate(14802 -11200)">
        <rect
          data-name="Ret\xE2ngulo 1448"
          width={32}
          height={32}
          rx={5}
          transform="translate(-14802 11200)"
          fill="#def4ee"
        />
        <path
          data-name="Caminho 576"
          d="M-14779.359 11209.594a3.985 3.985 0 00-5.6-.009l-7.01 7.018a5.408 5.408 0 00-1.587 3.84v2.321a1.035 1.035 0 001.036 1.036h2.32a5.4 5.4 0 003.839-1.588l7-7a3.975 3.975 0 00.002-5.618zm-8.465 11.151a3.346 3.346 0 01-2.376.982h-1.284v-1.284a3.348 3.348 0 01.981-2.376l4.622-4.624 2.678 2.679zm7-7l-.915.915-2.678-2.682.914-.915a1.894 1.894 0 012.678 2.679z"
          fill="#008560"
        />
      </g>
    </svg>
  );
}

export default SvgGrupo2662;

